import React from "react";
import Modal from "react-modal";
import Icon from "@mdi/react";
import { mdiClose } from "@mdi/js";

const styles = {
  overlay: {
    backgroundColor: "rgba(0,0,0,0.6)"
  },
  content: {
    background: "transparent",
    border: "none",
    overflow: "hidden",
    inset: 0,
    padding: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }
};

export default ({ show, toggle, children }) => {
  return (
    <Modal isOpen={show} style={styles}>
      <div className="dialog">
        <Icon
          path={mdiClose}
          size="20px"
          color="white"
          className="dialog_close"
          onClick={toggle}
        />
        {children}
      </div>
    </Modal>
  );
};
